import { render, staticRenderFns } from "./ebookcollect.html?vue&type=template&id=c4d93882&scoped=true&"
import script from "./ebookcollect.js?vue&type=script&lang=js&"
export * from "./ebookcollect.js?vue&type=script&lang=js&"
import style0 from "./ebookcollect.sass?vue&type=style&index=0&id=c4d93882&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d93882",
  null
  
)

component.options.__file = "ebookcollect.vue"
export default component.exports